import { createContext } from 'react'

export const CreditContext = createContext({})